// import Repository from '@/libs/axios'
import OperationsRepository from '@/libs/customAxios/operationAxios'
import ListsRepository from '@/libs/customAxios/listsAxios'

const RiderResource = '/admin/rider'
export default {
  getAllRiderList() {
    return OperationsRepository.get(`${RiderResource}`)
  },
  getAllRiderDropDown() {
    return OperationsRepository.get(`${RiderResource}?noPagination`)
  },
  getDriverListForDropdown() {
    return OperationsRepository.get(`${RiderResource}/drivers`)
  },
  getAllRidersForDropdown() {
    return ListsRepository.get(`${RiderResource}/all-riders-dropdown`)
  },
}
